import React, { useState } from "react";
import HostsList from "./HostsList";
import LoadSimple from "../../LoadSimple";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";

const TableHosts = ({
  pageActual,
  limitList,startLimit,
  devices,
  dataList,
  cisSelected,
  setCisSelected,
  registerIsValid,
  searchResults,
  setSearchResults,
  onSearch,
  dataUsers,
  setDataUsers,
  searchTerm,
  setSearchTerm,
  server,
  setRegisterIsValid,
  setData,
  setLoading,
  setError,
  handleChangEdit,
  languaje,
  mode,
  setContRowSelected,
  poolRows,setPoolRows,
  handleShowPopup,
  buscar_cis,
  poolObjectRows,
  setPoolObjectRows,
  loadingList
}) => {
  const [allSelected, setAllSelected] = useState(false);
  setContRowSelected(poolRows.length)
  const rowSelected = (elemento) => {
    if (allSelected) {
      setAllSelected(false)
    }
    setPoolRows((prevRows) => {
      // Busca si el hostid ya existe en el array
      const exists = prevRows.includes(elemento.hostid);
      
      // Si existe, filtra para eliminarlo, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(hostid => hostid !== elemento.hostid);
      } else {
        return [...prevRows, elemento.hostid];
        
      }
    });
    setPoolObjectRows((prevRows) => {
      // Busca si el hostid ya existe en el array
      const exists = prevRows.includes(elemento.hostid);
      
      // Si existe, filtra para eliminarlo, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(hostid => hostid !== elemento.hostid);
      } else {
        return [...prevRows, {'id':elemento.hostid,'name':elemento.host}];
        
      }
    });
  };
  const handleSelectAll = () => {
    if (allSelected) {
      // Si ya está todo seleccionado, deselecciona todo
      setPoolRows([]);
    } else {
      // Si no, selecciona todos los elementos
      // setPoolRows(dataList
      //   .slice(startLimit, parseInt(pageActual) * parseInt(limitList)));
        // setPoolRows(dataList);
        setPoolRows(dataList.map(item => item.hostid))
    }
    setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
  };
  return (
    <div className="cont-table-portafolio">
      <div className={"head-table-portafolio"+mode}>
      <div className="compact-head-table-portafolio">
      <div className="field-head-table-mantenimiento field-small">  <div className='cont-checkbox'>
                 <input type='checkbox' className='NotifiCheckBox ' checked={allSelected} style={{height:'15px'}}  onClick={()=>handleSelectAll()} ></input>
                </div></div>
                
        <div className="field-head-table-mantenimiento field-small"> ID</div>
        <div className="field-head-table-mantenimiento field-larger" style={{width:'20%'}} >{capitalizeFirstLetter(lang[languaje]['hostPadre'])} </div>
        <div className="field-head-table-mantenimiento field-medium" style={{width:'20%'}}>{capitalizeFirstLetter(lang[languaje]['hostHijo'])}</div>
        <div className="field-head-table-mantenimiento field-medium" style={{width:'10%'}}>{capitalizeFirstLetter(lang[languaje]['medio'])}</div>
        <div className="field-head-table-mantenimiento field-medium" style={{width:'10%'}}>{capitalizeFirstLetter(lang[languaje]['enlace'])}-{capitalizeFirstLetter(lang[languaje]['estatus'])}</div>
        <div className="field-head-table-mantenimiento field-medium" style={{width:'10%'}}>{capitalizeFirstLetter(lang[languaje]['enlace'])}-{capitalizeFirstLetter(lang[languaje]['traficoSaliente'])}</div>
        <div className="field-head-table-mantenimiento field-medium" style={{width:'10%'}}>{capitalizeFirstLetter(lang[languaje]['enlace'])}-{capitalizeFirstLetter(lang[languaje]['traficoEntrante'])}</div>
        <div className="field-head-table-mantenimiento field-medium" style={{width:'10%'}}>{capitalizeFirstLetter(lang[languaje]['enlace'])}-{capitalizeFirstLetter(lang[languaje]['alineacion'])}</div>
        {/* <div className="field-head-table-mantenimiento field-medium" >{capitalizeFirstLetter(lang[languaje]['longitud'])}</div> */}
        {/* <div className="field-head-table-mantenimiento field-larger" style={{width:'15%'}}  >{capitalizeFirstLetter(lang[languaje]['tecnologia'])}</div>
        
        <div className="field-head-table-mantenimiento field-medium" >{'Status'}</div> */}
        <div className="field-head-table-mantenimiento field-medium" >{capitalizeFirstLetter(lang[languaje]['acciones'])}</div>
        </div>
      </div>
      <div className="body-table-portafolio">
        {registerIsValid ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          <HostsList
            pageActual={pageActual}
             limitList={limitList} startLimit={startLimit}
            dataList={dataList}
            devices={devices}
            cisSelected={cisSelected}
            setCisSelected={setCisSelected}
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            dataUsers={dataUsers}
            setDataUsers={setDataUsers}
            server={server}
            setRegisterIsValid={setRegisterIsValid}
            setData={setData}
            setLoading={setLoading}
            setError={setError}
            handleChangEdit={handleChangEdit}
            languaje={languaje}
            mode={mode}
            setContRowSelected={setContRowSelected}
            rowSelected={rowSelected}
            poolRows={poolRows}
            handleShowPopup={handleShowPopup}
            buscar_cis={buscar_cis}
            loadingList={loadingList}
          ></HostsList>
        )}
      </div>
    </div>
  );
};

export default TableHosts;
